import React from 'react';

/** Ornament — "—— ✦ ——" divider used under subtitles. */
export default function Ornament({ className = '', compact = false }) {
  return (
    <span className={`ornament${compact ? ' ornament--compact' : ''}${className ? ` ${className}` : ''}`} aria-hidden="true">
      <i />
      <span>✦</span>
      <i />
    </span>
  );
}
